module.exports = __webpack_public_path__ + "img/705B4B_312821_AF927B_44342C-256px.cf7d3bde.png";